<!--
 * @FileDescription: API秘钥管理页面
 -->
<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('currentLocation') }} > {{ $t('aPIKeyManagement') }}</div>
    <div class="main common-table-cnt search">
      <!-- 查询表单 -->
      <el-form :inline="true" :model="formInline" class=" demo-form-inline">
        <el-form-item label="APP key">
          <el-input v-model="formInline.ak" clearable placeholder="APP Key"></el-input>
        </el-form-item>
        <el-form-item :label="$t('createUser')">
          <el-input v-model="formInline.userName" clearable :placeholder="$t('createUser')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('state')">
          <el-select v-model="formInline.enable" clearable :placeholder="$t('state')">
            <el-option :label="$t('enable')" value="1"></el-option>
            <el-option :label="$t('disable')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <!-- table开始 -->
        <el-table :data="tableData" style="width: 100%" height="635" @sort-change="sortChange">
          <el-table-column
            type="index"
            :index="indexMethod"
            :label="$t('SerialNo')"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="appKey" label="APP key" sortable="appKey" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column
            prop="secretKey"
            label="Secret key"
            sortable="secretKey"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="creator"
            :label="$t('createUser')"
            sortable="creator"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="createdTime"
            :label="$t('creationTime')"
            sortable="createdTime"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="enable"
            :label="$t('state')"
            width="100"
            sortable="enable"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              {{ scope.row.enable === 1 ? $t('enable') : '' }}
              {{ scope.row.enable === 0 ? $t('disable') : '' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('operationh')" min-width="50">
            <template slot-scope="scope">
              <span class="editClick" @click="enableSecret(scope.row.id, 1)" v-if="scope.row.enable === 0">{{
                $t('enable')
              }}</span>
              <span class="editClick" @click="enableSecret(scope.row.id, 0)" v-if="scope.row.enable === 1">{{
                $t('disable')
              }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询参数
      formInline: {
        userName: '',
        ak: '',
        enable: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
    }
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.getList()
    },
    // 点击查询列表
    getList() {
      this.currentPage = 1
      this.search()
    },
    // 获取列表
    search() {
      let params = {
        ak: this.formInline.ak,
        userName: this.formInline.userName,
        enable: this.formInline.enable,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        specType: this.formInline.specType,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      findSecret(params).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    // 禁用启用api秘钥
    enableSecret(id, enable) {
      if (enable === 1) {
        enableSecret(id).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('enabledApiSecret'),
              duration: 1000,
            })
            for (let item of this.tableData) {
              if (item.id === id) {
                item.enable = 1
              }
            }
          }
        })
      } else if (enable === 0) {
        disableSecret(id).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('disabledApiSecret'),
              duration: 1000,
            })
            for (let item of this.tableData) {
              if (item.id === id) {
                item.enable = 0
              }
            }
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    indexMethod(index) {
      return index + 1
    },
  },
  mounted() {
    this.search()
  },
}
import { findSecret, enableSecret, disableSecret } from '@/api/secret/secret'
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.base_main
  .title
    font-size 16px
    margin-bottom 28px
  .main
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .editClick
      margin-left 16px
      cursor pointer
    .pagination
      float right
      margin-top 1%
  .linetwo
    display flex
    overflow hidden
    flex-direction row
    .leftColumn
      flex 0 0 50%
    .rightColumn
      flex 0 0 50%
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 644px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
>>>.el-popper
 min-width 100%!important
</style>
